import Vue from "vue";
import VueRouter, { Route, RouteConfig } from "vue-router";
import ContractWithdrawalEmail from "@/pages/contract/ContractWithdrawalEmail.vue";
import ContractWithdrawalError from "@/pages/contract/ContractWithdrawalError.vue";
import ContractWithdrawalIdentify from "@/pages/contract/ContractWithdrawalIdentify.vue";
import ContractWithdrawalOtp from "@/pages/contract/ContractWithdrawalOtp.vue";
import ContractWithdrawalPhone from "@/pages/contract/ContractWithdrawalPhone.vue";
import ContractWithdrawalResult from "@/pages/contract/ContractWithdrawalResult.vue";
import Login from "@/pages/login/Login.vue";
import LoginConsent from "@/pages/login/LoginConsent.vue";
import LoginOtp from "@/pages/login/LoginOtp.vue";
import LoginPhone from "@/pages/login/LoginPhone.vue";
import LoginVerifyPhone from "@/pages/login/LoginVerifyPhone.vue";
import PasswordSet from "@/pages/pwd/PasswordSet.vue";
import PasswordOtp from "@/pages/pwd/PasswordOtp.vue";
import PasswordResult from "@/pages/pwd/PasswordResult.vue";
import PasswordPhone from "@/pages/pwd/PasswordPhone.vue";
import PasswordVerifyPhone from "@/pages/pwd/PasswordVerifyPhone.vue";
import Error from "@/pages/Error.vue";
import Path from "./PathEnum";
import Name from "./NameEnum";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
    {
        path: Path.PASSWORD_SET,
        name: Name.PASSWORD_SET,
        component: PasswordSet,
        meta: {
            title: "pwd.set.page_title"
        }
    },
    {
        path: Path.PASSWORD_OTP,
        name: Name.PASSWORD_OTP,
        component: PasswordOtp,
        props: true,
        meta: {
            title: "pwd.set.page_title"
        }
    },
    {
        path: Path.PASSWORD_RESULT,
        name: Name.PASSWORD_RESULT,
        component: PasswordResult,
        meta: {
            title: "pwd.set.page_title"
        }
    },
    {
        path: Path.PASSWORD_ERROR,
        name: Name.PASSWORD_ERROR,
        component: Error,
        props: true,
        meta: {
            title: "pwd.set.page_title"
        }
    },
    {
        path: Path.PASSWORD_PHONE,
        name: Name.PASSWORD_PHONE,
        component: PasswordPhone,
        meta: {
            title: "pwd.set.page_title"
        }
    },
    {
        path: Path.PASSWORD_VERIFY_PHONE,
        name: Name.PASSWORD_VERIFY_PHONE,
        component: PasswordVerifyPhone,
        meta: {
            title: "pwd.set.page_title"
        }
    },
    {
        path: Path.LOGIN,
        name: Name.LOGIN,
        component: Login,
        meta: {
            title: "login.page_title"
        }
    },
    {
        path: Path.LOGIN_OTP,
        name: Name.LOGIN_OTP,
        component: LoginOtp,
        props: true,
        meta: {
            title: "login.page_title"
        }
    },
    {
        path: Path.LOGIN_CONSENT,
        name: Name.LOGIN_CONSENT,
        component: LoginConsent,
        props: true,
        meta: {
            title: "login.page_title"
        }
    },
    {
        path: Path.LOGIN_ERROR,
        name: Name.LOGIN_ERROR,
        component: Error,
        props: true,
        meta: {
            title: "login.page_title"
        }
    },
    {
        path: Path.LOGIN_PHONE,
        name: Name.LOGIN_PHONE,
        component: LoginPhone,
        meta: {
            title: "login.page_title"
        }
    },
    {
        path: Path.LOGIN_VERIFY_PHONE,
        name: Name.LOGIN_VERIFY_PHONE,
        component: LoginVerifyPhone,
        meta: {
            title: "login.page_title"
        }
    },
    {
        path: Path.CONTRACT_WITHDRAWAL,
        name: Name.CONTRACT_WITHDRAWAL,
        component: ContractWithdrawalIdentify,
        meta: {
            title: "contract_withdrawal.page_title"
        }
    },
    {
        path: Path.CONTRACT_WITHDRAWAL_OTP,
        name: Name.CONTRACT_WITHDRAWAL_OTP,
        component: ContractWithdrawalOtp,
        props: true,
        meta: {
            title: "contract_withdrawal.page_title"
        }
    },
    {
        path: Path.CONTRACT_WITHDRAWAL_PHONE,
        name: Name.CONTRACT_WITHDRAWAL_PHONE,
        component: ContractWithdrawalPhone,
        meta: {
            title: "contract_withdrawal.page_title"
        }
    },
    {
        path: Path.CONTRACT_WITHDRAWAL_EMAIL,
        name: Name.CONTRACT_WITHDRAWAL_EMAIL,
        component: ContractWithdrawalEmail,
        meta: {
            title: "contract_withdrawal.page_title"
        }
    },
    {
        path: Path.CONTRACT_WITHDRAWAL_RESULT,
        name: Name.CONTRACT_WITHDRAWAL_RESULT,
        component: ContractWithdrawalResult,
        props: true,
        meta: {
            title: "contract_withdrawal.page_title"
        }
    },
    {
        path: Path.CONTRACT_WITHDRAWAL_ERROR,
        name: Name.CONTRACT_WITHDRAWAL_ERROR,
        component: ContractWithdrawalError,
        props: true,
        meta: {
            title: "contract_withdrawal.page_title"
        }
    }
];

const router = new VueRouter({
    mode: "history",
    routes
});

router.beforeEach((to: Route, from: Route, next: Function) => {
    document.title = Vue.prototype.$localize(to.meta?.title || "Default Title");
    next();
});

export default router;
